import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import "../styles/PicPrintPreview.css";

const PrintPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { images } = location.state || [];  // 受け取った画像リスト

  useEffect(() => {
    // ページがロードされたときに自動で印刷プレビューを表示
    const timeoutId = setTimeout(() => {
      window.print(); // 少し遅らせてから呼び出す
    }, 500);

    // 印刷完了後に前のページに戻る処理
    const handleAfterPrint = () => {
      navigate(-1);  // 一つ前のページに戻る
    };

    window.onafterprint = handleAfterPrint;

    // クリーンアップ
    return () => {
      clearTimeout(timeoutId);  // setTimeoutのクリア
      window.onafterprint = null;  // イベントハンドラの解除
    };
  }, [navigate]);

  return (
    <div>
      <div className="image-list">
        {images.map((image, index) => (
          <div key={index} className="image-item">
            <img 
              src={image.url} 
              alt={`商品画像${index}`} 
              style={{ width: `${image.width}mm` }}  // 選択された横幅で画像を表示
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrintPreview;
